export default (api) => ({
  getAuditTrail: (params) => api.get('/audit-trail', { params }),
  getTypesList: () => api.get('/audit-trail/types'),
  getCommentExamples: () => api.get('/audit-trail/examples'),
})
